// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2pWtA","footer":"Form_footer__1duVb"};